import { render, staticRenderFns } from "./followUp.vue?vue&type=template&id=1113c3fc&scoped=true"
import script from "./followUp.vue?vue&type=script&lang=js"
export * from "./followUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1113c3fc",
  null
  
)

export default component.exports